import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  disabled = false,
  type = 'button',
  className = ''
}) => {
  const getClassName = () => {
    switch (variant) {
      case 'primary':
        return 'action-btn';
      case 'secondary':
        return 'action-btn secondary';
      case 'purple':
        return 'action-btn purple';
      case 'danger':
        return 'action-btn danger';
      default:
        return 'action-btn';
    }
  };

  return (
    <button
      type={type}
      className={`${getClassName()} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;